import { createGlobalStyle } from 'styled-components'

import { theme } from './theme'

const GlobalStyles = createGlobalStyle`
  * {
    font-family: 'Roboto', sans-serif;
    box-sizing: border-box;
  }
  html {
    overflow-y: scroll;
  }
  body {
    overflow-x: hidden;
    margin: unset;
  }
  .flex-1 {
    flex: 1;
  }
  .bold {
    font-weight: bold;
  }
  .anticon svg {
    color: ${theme.primaryColor};
  }
  .fit-alert .anticon svg {
    color: unset;
  }
  .delivery-note-not-found-icon.anticon svg {
    color: ${theme.red};
  }
  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: white;
    border-color: black;
    &:after {
      border-color: black;
    }
  }
  .ant-table-thead > tr > th {
    color: ${theme.textColor} !important;
    text-align: left;
    font-weight: 600;
    border-bottom: 1px solid ${theme.white};
  }
  .ant-table-thead > tr > th[colspan]:not([colspan='5']) {
    border: 1px solid ${theme.white};
  }
  .ant-table-tbody > tr > td {
    color: ${theme.textColor} !important;
    text-align: left;
  }
  .ant-scrolling-effect {
    width: 100% !important;
  }
  .ant-modal {
    top: 3rem;
  }
  .ant-picker-disabled,
  .ant-select-disabled {
    .ant-picker.ant-picker-disabled,
    .ant-select-selector {
      color: ${theme.lightBlack} !important;
      background: unset !important;
      border: unset !important;
    }
    .ant-picker-suffix,
    .ant-select-arrow {
      display: none;
    }
  }
  .ant-picker-input > input[disabled],
  .ant-picker.ant-picker-disabled {
    color: ${theme.lightBlack} !important;
    background: unset !important;
    border: unset !important;
  }
  .p-datatable .p-datatable-thead > tr > th {
    background: white !important;
  }
  .ant-table-content {
    font-size: 0.85rem;
  }
  .dashboard-badge svg {
    fill: ${theme.secondaryDarkGray};
  }
  .menu-badge .ant-badge-count {
    transform: translate(80%, -50%);
  }
  .menu-badge svg {
    fill: ${theme.textColor};
    transition: all ease 300ms !important;
  }
  .ant-menu-item-active .menu-badge svg {
    fill: ${theme.primaryColor};
  }
  .menu-badge .ant-badge-multiple-words {
    padding: 0 0.25rem;
  }
  .ant-badge-count {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .display-none {
    display: none !important;
  }
  .p-datepicker table td > span.p-highlight {
    background: ${theme.primaryColor};
    color: #fff;
    border-radius: 3px;
    box-shadow: none;
  }
  .p-datepicker table td > span:focus {
    box-shadow: none;
  }
  .p-datepicker table td > span {
    border-radius: 3px;
  }
  .p-calendar {
    width: 100%;
  }
  .p-calendar:hover {
    color: ${theme.primaryColor} !important;
  }
  .p-component {
    font-family: 'Roboto', sans-serif;
    font-size: 14px;
    box-shadow: none;
    cursor: pointer;
  }
  .p-inputwrapper-focus {
    box-shadow: none;
    border: none;
  }
  .p-inputwrapper {
    height: 32px;
    box-shadow: none;
  }
  .p-inputtext:enabled:hover {
    border-color: ${theme.primaryColor};
  }
  .p-button {
    background: ${theme.primaryColor};
    border-color: ${theme.primaryColor};
  }
  .p-button:enabled:hover {
    background: #54739e;
    border-color: #54739e;
    color: #fff;
  }
  .p-datepicker:not(.p-disabled) table td span:not(.p-highlight):not(.p-disabled):focus {
    box-shadow: none;
  }
  .p-calendar-w-btn-right .p-inputtext {
    color: rgba(0, 0, 0, 0.85);
  }
  .p-datepicker table {
    font-size: .9rem;
  }
  .p-datepicker .p-timepicker span {
    font-size: .9rem;
  }
  .p-datepicker table td.p-datepicker-today > span.p-highlight {
    background: ${theme.primaryColor};
    color: #fff;
    border-radius: 3px;
    box-shadow: none;
  }
  .p-button.p-button-secondary.p-button-text:enabled:focus {
    box-shadow: none;
  }
  .p-inputtext:enabled:focus {
    box-shadow: none;
    border-color: ${theme.primaryColor};
  }
  .p-button:focus {
    box-shadow: none;
  }
  .clear-button {
    color: #607D8B;
    background: transparent;
    border: none;
  }
  .clear-button:hover {
    background: #e9ecef;
    color: #607D8B;
  }
  .p-datepicker table td {
    padding: 0.05rem !important;
  }
  .p-datepicker .p-timepicker {
    padding: .02rem;
  }
  .p-datepicker .p-datepicker-buttonbar {
    padding: .3rem;
  }
  #simulation-table .ant-table-cell {
    vertical-align: top;
  }
  .p-radiobutton .p-radiobutton-box:not(.p-disabled).p-focus {
    box-shadow: none;
    border-color: ${theme.primaryColor};
  }
  .p-radiobutton .p-radiobutton-box:not(.p-disabled):not(.p-highlight):hover {
    border-color: #355891c7;
  }
  .p-radiobutton .p-radiobutton-box.p-highlight:not(.p-disabled):hover {
    border-color: #355891c7;
    background-color: #355891c7;
  }
  .p-radiobutton .p-radiobutton-box.p-highlight {
    background-color: ${theme.primaryColor};
    border-color: ${theme.primaryColor};
  }
  #radio-button .p-disabled, .p-disabled * {
    background-color: gray !important;
    border-color: gray;
  }
  .map-container {
    width: 100%;
    height: 60vh;
  }
  ::-webkit-scrollbar {
    width: 0.25rem;
    height: 0.25rem;
  }
  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 0.25rem ${theme.lightGray};
    border-radius: 0.25rem;
  }
  ::-webkit-scrollbar-thumb {
    background: ${theme.scrapBlue};
    border-radius: 10px;
    height: 4rem;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: ${theme.darkGray};
  }
  .zebra-even {
    background-color: #ffffff;
  }  
  .zebra-odd {
    background-color: #0c68fc00;
  }
  .ant-table-tbody > tr:hover > td {
    background-color: transparent !important;
    color: inherit !important;
  }
  .ant-table-row.ant-table-row-level-0 > tr:hover {
    background-color: transparent !important;
    color: inherit !important;
  } 
  .checkbox-label {
    display: flex;
    align-items: center;
  }
  .carrier-selection-table {
    flex: 1;
    display: flex;
    width: auto;
    overflow-y: hidden;
    min-width: 25rem;
    max-width: 50rem;
    .ant-spin-nested-loading {
      display: flex;
      flex: 1;
      .ant-spin-container {
        display: flex;
        flex: 1;
        .ant-table {
          display: flex;
          flex: 1;
          .ant-table-container {
            display: flex;
            flex: 1;
            flex-direction: column;
            .ant-table-header {
              display: flex;
              overflow: unset !important;
              border-bottom: 1px solid #00000040;
              .ant-table-thead > tr > th {
                padding: 0.25rem 0.75rem 0.25rem 0.5rem !important;
                font-size: 0.75rem;
                .ant-table-column-title {
                  text-align: center;
                }
              }
            }
            .ant-table-body {
              display: flex;
            }
            .ant-table-content {
              display: flex;
              flex: 1;
            }
          }
        }
      }
    }
    .ant-table-tbody > tr {
      transition: all ease-in-out 300ms;
      > td {
        padding: 0.5rem 0;
        background-color: unset;
        background: unset;
      }
    } 
    .ant-table-tbody > tr.ant-table-row-selected {
      background-color: ${theme.lightGray}50;
      > 
      td {
        background-color: unset !important;
        background: unset !important;
      }
    }

          .ant-table .ant-table-tbody > tr.row-CONFIRMED_CARRIER:not(.expandable-row) { // "Confirmed Carrier color rows"
      background-color: ${theme.carrierTableColors.CONFIRMED} !important;
    }

    .ant-table .ant-table-tbody > tr.row-PENDING_CARRIER:not(.expandable-row) { // "Pending carrier color rows"
      background-color: ${theme.carrierTableColors.PENDING} !important;
    }


    .carrier-column-header {
      justify-content: center;
      align-items: center;
    }
    th.ant-table-cell:has(.column-SELECTED_EQUIPMENT_COLUMN) {
      background-color: ${theme.carrierTableColors.SELECTED_EQUIPMENT_COLUMN};
    }
    .ant-table-body {
      overflow-y: scroll;
    }
    .ant-table-cell {
      padding: unset !important;
      height: 2.5rem;
    }
  }
  .carrier-table-status-header {
    align-items: flex-end;
    justify-content: space-between;
    .ant-tooltip {
      max-width: unset;
    }
    .ant-form-item-control {
      transform: translateY(-1.675rem);
    }
  }
  .carrier-table-status-ref-sample {
    height: 1.5rem;
    width: 2rem;
    border-radius: 0.25rem;
    border: 1px solid #00000030;
  }
  .required-asterisk {
    display: inline-block;
    margin-right: 4px;
    color: #ff4d4f;
    font-size: 14px;
    font-family: SimSun, sans-serif;
    line-height: 1;
  }
  .carrier-table-status-equipment-header {
    text-align: center;
  }
  .carrier-table-status__tooltip-refs {
    max-width: unset;
  }
  .carrier-table-status__tooltip-refs__title {
    gap: 0.5rem;
    padding: 0.5rem;
  }
  .carrier-table-status__tooltip-refs__status-row {
    gap: 0.25rem;
    align-items: center;
  }
  .carrier-table-status__tooltip-refs__status-row__description {
    white-space: nowrap;
  }
  .disabled-input-opacity {
    opacity: 0.5;
  }
  .accept-ticket-modal {
    .carrier-form-row {
      .ant-form-item {
        margin-bottom: unset;
        .ant-form-item-row {
          flex-wrap: wrap;
        }
      }
    }
    .ant-form {
      display: flex;
      flex-wrap: wrap;
      flex-direction: column;
      gap: 0.675rem;
      margin-bottom: 1.5;
    }
  }
  .add-additional-data-ticket-modal {
    .hide-feedback .ant-form-item-explain {
      display: none;
    }
    .ticket-sap-row {
      min-height: 4rem;
      align-items: flex-start;
      .ant-input-affix-wrapper-disabled {
        color: unset !important;
        background-color: unset !important;
        border: none !important;
        box-shadow: none;
      }
    }
    .carrier-form-row {
      .ant-form-item {
        margin-bottom: unset;
      }
    }
  }
  .asnum-cell {
    gap: 0.75rem;
    justify-content: space-between;
    span {
      white-space: nowrap;
    }
  }
  .expandable-row {
    cursor: pointer;
  }
  .stripped-table tr:not(.expandable-row):nth-child(even) {
    background-color: ${theme.lightGray}50;
  }
  .stoplight {
    height: 5rem;
    width: 0.5rem;
    position: relative;
  }
  .barlight {
    width: 0.35rem;
    min-height: 100%;
  }  
  .stoplight.yellow, .barlight.yellow {
    background-color: ${theme.status.yellow} !important;
  }  
  .stoplight.green, .barlight.green {
    background-color: ${theme.status.green} !important;
  }  
  .stoplight.red, .barlight.red {
    animation: pulse 2s infinite;
    background-color: ${theme.status.red} !important;
  }
  @-webkit-keyframes pulse {
    0% {
      -webkit-box-shadow: 0 0 0 0 #e1394d41;
    }
    70% {
      -webkit-box-shadow: 0 0 0 0.5rem #e1394d00;
    }
    100% {
      -webkit-box-shadow: 0 0 0 0 #e1394d00;
    }
  }
  @keyframes pulse {
    0% {
      -moz-box-shadow: 0 0 0 0 #e1394d41;
      box-shadow: 0 0 0 0 #e1394d41;
    }
    70% {
      -moz-box-shadow: 0 0 0 0.5rem #e1394d00;
      box-shadow: 0 0 0 0.5rem #e1394d00;
    }
    100% {
      -moz-box-shadow: 0 0 0 0 #e1394d00;
      box-shadow: 0 0 0 0 #e1394d00;
    }
  }
  .ant-btn-default {
  background-color: #fbf8faff;
  }  
  .expandable-row:hover {
    background-color: #35589110 !important;
  }  

  .ant-scroll-number {
    transform: translate(190%, -10%) !important;
  }
  .ant-menu-item.ant-menu-item-selected {
  padding-left: 1.5rem !important;
  }
  .ant-menu-item {
  padding-left: 1.5rem !important;
  }

  .table-layout:hover {
    background-color: #35589110;
  }
  .bYrABc .filters-container .filters-list {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    height: 100%;
    overflow-y: hidden !important;
  }
    ::-webkit-scrollbar-thumb {
      background: #35589110;
      border-radius: 10px;
      height: 4rem;
  }
  .ant-table-row-level-0.expandable-row.odd-row:hover {
    background: #96bdfc65 !important;
  }
  .ant-select-selection-search {
    overflow-y: hidden !important;
  }
  .ant-table tr:not(.expandable-row):nth-child(even) {  // "striped rows"
    background-color: #f1f1f173 !important; 
  }
  .ant-col {
    border-radius: 20px;
    max-width: 100% !important;
  }
  .ant-table-expanded-row {
    .ant-table {
      margin-inline: unset !important;
    }
  }
  .ant-table-thead {
    border-radius: unset !important;
  }  
  .expandable-row {
    background-color: #ffffff !important;
  }  
  .expandable-row.odd-row {
    background-color: #f1f1f173 !important; 
  }
  .ant-table-row:hover {
  background-color: #96bdfc65 !important;
  }
  .ant-table-tbody > tr:hover > td {
  background-color: ${theme.rowHover} !important;
  }
  .column-width {
    max-width: 4rem;
  }
  .text-styles-row {
    overflow-wrap: break-word;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: wrap;
    align-content: center;
  }
.tag-hidden {
  width: 90%;
  background-color: transparent;
  border: none;
  overflow-wrap: break-word;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: wrap;
  align-content: center;
}
.column-id.text-styles-row {
  text-align: center;
  padding: 0.5rem;
  margin-left: -10px;
}
.ant-btn.ant-btn-default.ant-dropdown-trigger {
  background-color: transparent;
  border: none;
}
.ant-table-tbody.zebra-even {
  background-color: #0c68fc00;
}
.submenu-Ident {
  margin-left: 12px;
}

.custom-column {
  min-width: 7rem;
}
.custom-column-2 {
  min-width: 10rem;
}
.custom-column-3 {
  min-width: 3.75rem;
}
.ant-menu.ant-menu-submenu-title {
    transition: none !important;
}
.ant-table .ant-table-tbody > tr.row-VJE:not(.expandable-row) {
  background-color: #fbfbbeff !important;
}
.ant-table .ant-table-tbody > tr.row-TO:not(.expandable-row) {
  background-color: #e5d7fd !important;
}

.custom-select {
  font-size: 5rem !important;
}

.custom-select .ant-select-selection-item {
  font-size: 1rem !important;
}

.custom-select .ant-select-item {
  font-size: 1rem !important;
  line-height: 1.75rem;
}

.no-wrap-text {
  white-space: nowrap;
}
.d-none {
  display: none !important;
}

.cfr-error-message {
  color: red;
  font-size: 0.626rem;
  margin-top: 0.25rem;
  line-height: 1.4;
  max-width: 100%;
  white-space: normal;
}

.dates-quantity-container {
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: -0.75rem;
  margin-bottom: 0.5rem;
  transform: translateX(0.75rem);
}

.date-picker-form-item {
  width: 50%;
}

.contract-search-button {

  background-color: ${theme.scrapBlue};
  border-color: ${theme.scrapBlue};
  color: ${theme.lightGray};
}

.contract-search-button .anticon {
  color: white !important;
}

.contract-search-button .anticon svg {
  color: white !important;
  fill: white !important;
}

.contract-search-button:hover {
  background-color: ${theme.scrapBlue};;
  border-color: ${theme.scrapBlue};
  color: white !important;
}

.contract-search-button:hover .anticon {
  color: white !important;
}

.contract-search-button:hover .anticon svg {
  color: white !important;
  fill: white !important;
}

.contract-search-button:disabled {
  background-color: #c1c3c4 !important;
  border-color: #d9d9d9 !important;
  color: ${theme.darkGray};
}

.contract-search-button:disabled .anticon {
  color: rgba(0, 0, 0, 0.25) !important;
}

.contract-search-button:disabled .anticon svg {
  color: ${theme.darkGray};
  fill: ${theme.darkGray};
}

/* Estilo para placeholder de campos de contrato SOLO después de simulación */
.ticket-form.simulation-executed .ant-select .ant-select-selection-placeholder {
  color: #595959 !important;
}

/* Estilo específico para los campos de contrato cuando tienen opciones disponibles */
.ticket-form.simulation-executed .ant-form-item .ant-select .ant-select-selection-placeholder {
  color: #595959 !important;
}

/* Estilo para campos de contrato específicos cuando tienen datos */
.ticket-form.simulation-executed .ant-form-item:has([name="contract"]) .ant-select .ant-select-selection-placeholder,
.ticket-form.simulation-executed .ant-form-item:has([name="sapItemId"]) .ant-select .ant-select-selection-placeholder {
  color: #595959 !important;
}

.contract-suggestion-link {
  color: ${theme.scrapBlue};
  cursor: pointer;
  transition: color 0.2s;
}
.contract-suggestion-link:hover {
  color: ${theme.scrapBlue};
}
.suggestion-option {
  background-color: ${theme.status.green}40 !important;
}
.suggestion-option:hover {
  background-color: ${theme.status.green}60 !important;
}

.input-number-requirent {
  text-align: center;
  background-color: #ffffff;
  color: #000000;
  border: 1px solid #d9d9d9;
  cursor: default;
  min-width: 5.5rem;
}

.centered-spinner {
  position: fixed;
  top: 25%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
}

.priority-flag {
  background-color: #FFF4CC;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: bold;
  color: #333;
}

.priority-flag-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

// Estilos para el contenedor del WebSocket y UserInfo en el header
.websocket-user-container {
  margin-right: 0.25rem;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
}

// Estilos para el indicador WebSocket
.websocket-indicator {
  display: flex;
  align-items: center;
  margin-right: 3px;
  height: 100%;
}

.websocket-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.websocket-dot.connected {
  background-color: #52c41a;
}

.websocket-dot.disconnected {
  background-color: #ff4d4f;
}

// Estilos para botones de ubicación en AdminEVouchers
.location-button {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  text-align: left;
  padding-left: 0;
  margin-top: min(20px, 40px);
  margin-bottom: min(20px, 40px);
}

.location-text {
  white-space: normal;
}

// Estilos para iconos de botones
.option-button-icon {
  font-size: 18px;
}

// Estilos para contenedores flex
.flex-spacer {
  flex: 1;
}

// Estilos para spinner de carga en Ongoing
.loading-spinner-overlay {
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2;
  background-color: #ffffff90;
}

@media (max-width: 1024px) {
  .date-from-to-picker-dropdown.ant-picker-dropdown {
    max-height: 85vh;
    overflow-y: auto;
    position: fixed !important;
    left: 50% !important;
    top: 50% !important;
    transform: translate(-50%, -50%) !important;
    margin: 0 !important;
  }
  .date-from-to-picker-dropdown .ant-picker-panel-container {
    max-height: 75vh;
    overflow-y: auto;
    box-shadow: 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
    border-radius: 8px;
  }
  .date-from-to-picker-dropdown .ant-picker-panels {
    flex-wrap: wrap;
    max-width: 100%;
  }
  .date-from-to-picker-dropdown .ant-picker-panel {
    border-right: none;
    flex: 1 1 auto;
    min-width: 280px;
  }
  .date-from-to-picker-dropdown .ant-picker-content th,
  .date-from-to-picker-dropdown .ant-picker-content td {
    padding: 4px;
    font-size: 12px;
  }
  .date-from-to-picker-dropdown .ant-picker-cell-inner {
    min-width: 28px;
    font-size: 12px;
  }
}

@media (max-width: 576px) {
  .date-from-to-picker-dropdown .ant-picker-panels {
    flex-direction: column;
  }
  .date-from-to-picker-dropdown .ant-picker-panel {
    min-width: 100%;
  }
  .date-from-to-picker-dropdown .ant-picker-cell-inner {
    min-width: 32px;
  }
}

.monthly-supplier-metrics-table {
  .header-cell-month-label {
    background-color: ${theme.primaryColor} !important;
    color: #fff !important;
  }
  .no-separator::after, .no-separator::before {
    display: none !important;
  }
  .no-border {
    border-top-width: 0px !important;
    border-bottom: 1px solid #f0f0f0 !important;
    border-left: 0 !important;
  }
}

`

export { GlobalStyles }
